import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Ambulance, Plane, Users, GraduationCap, CheckCircle } from "lucide-react";
import { services } from "../data/mock";

const iconMap = {
  Ambulance: Ambulance,
  Plane: Plane,
  Users: Users,
  GraduationCap: GraduationCap,
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600">
            Comprehensive medical support tailored to your event needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="border-2 hover:border-[#0056c5] transition-all duration-300 hover:shadow-xl group"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-[#0056c5]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#0056c5] transition-colors">
                    <IconComponent className="h-8 w-8 text-[#0056c5] group-hover:text-white transition-colors" />
                  </div>
                  <CardTitle className="text-2xl text-gray-900">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-base">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <CheckCircle className="h-5 w-5 text-[#0056c5] flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Event Types */}
        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Events & Services We Cover
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {[
              "Marathons",
              "Food Festivals",
              "Motorsport Events",
              "Firework Displays",
              "Family Fun Days",
              "Concerts",
              "Sports Events",
              "Corporate Events",
              "Patient Repatriation",
              "Medical Transport",
            ].map((event, index) => (
              <div
                key={index}
                className="text-center py-3 px-4 bg-gray-50 rounded-lg hover:bg-[#0056c5] hover:text-white transition-colors cursor-default"
              >
                <span className="font-medium text-sm">{event}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
